<script>
  /**
   * スキーマに基づいた入力欄を表示するコンポーネント
   */
  export let id
  export let field
  export let checked = undefined
  export let value = undefined
</script>

{#if field}
  {@const { name, label, editor } = field}
  <svelte:component
    this={editor.component}
    {id}
    {name}
    {label}
    {...editor.props}
    bind:value
    bind:checked
  />
{/if}
